import axios from "axios";
import {baseUrl} from "config";
import {getIdToken} from "service";
import {history} from "load/store";

const axiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 30000,
});

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

const checkTokenExpiry = (token) => {
    return !!(parseJwt(token)?.exp * 1000 < Date.now());
};

const redirectToLogout = () => {
  history.replace({pathname: "/logout", state: {error: "Session timeout"}});
}

axiosInstance.interceptors.request.use((config) => {
        const token = getIdToken();
        if (token) {
          if (!checkTokenExpiry(token)) {
            config.headers.Authorization = "Bearer " + getIdToken();
          } else {
            redirectToLogout();
            Promise.reject("Session timeout");
          }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    });

export default axiosInstance;
